<template>
<div  :aria-busy="loading ? 'true' : 'false'">

		<div v-if="!loading">
			<section class="content__custom">
				<div class="main-title">
					<h1 class="answers">
						{{ 'intention-name' | translate }}: {{ theme.tag | titleCase }}
					</h1>
				</div>
				<div v-for="(knowledge, index) in knowledge" :key="knowledge.id">
					<div class="boxes">
						<div class="box">
							<myKnowledge
								:knowledgeActiveProp="knowledge.active === null ? 0 : knowledge.active"
								:knowledgeAnswerProp="knowledge.answer"
								:knowledgeCreatedAtProp="knowledge.created_at"
								:knowledgeIdProp="knowledge.id"
								:knowledgeSavedAttachmentIdProp="knowledge.saved_attachment_id"
								:knowledgeSavedAttachmentTypeProp="knowledge.saved_attachment_type"
								:knowledgeTypeProp="knowledge.type"
								:knowledgeUpdatedAtProp="knowledge.updated_at"
								:knowledgeIndexProp="(index)">
							</myKnowledge>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</div>
</template>
<script>
import myKnowledge from './myKnowledge.vue';

export default {
	name: 'detailsPendingThemes',
	components: {
		myKnowledge,
	},
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
				intentId: this.$route.query.id,
			},
			knowledgeForm: {
				success: false,
			},
			loading: false,
		};
	},
	computed: {
		theme() {
			return (this.$store.state.entity || []).intent || [];
		},
		knowledge() {
			const knowledge = (this.$store.state.entity.intent || []).knowledge_base || [];

			function compare(a, b) {
				const typeA = a.type.toUpperCase();
				const typeB = b.type.toUpperCase();
				let comparison = 0;
				if (typeA > typeB) {
					comparison = 1;
				} else if (typeA < typeB) {
					comparison = -1;
				}
				return comparison;
			}
			return knowledge.sort(compare);
		},
		success() {
			return this.$store.state.status;
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getIntent', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/entity/knowledgeDetails.vue